// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__1WqFt","controls":"Popup_controls__2oTHJ"};